module.exports = __webpack_public_path__ + "img/sender-owner-disabled.8165c81f.svg";